import React, { useState } from 'react';
import './CertificatesPage.css'; // Ensure the CSS is imported for styling

import certificationsimage1 from "../assets/img/IEC_Code_EFPL_page-0001.jpg";
import certificationsimage2 from "../assets/img/FSSAI_License_EFPL_page-0001.jpg";
import certificationsimage3 from "../assets/img/Certificate_of_Incorporation_EFPL_page-0001.jpg";
import certificationsimage4 from "../assets/img/UDHYAM_AADHAR_EFPL_001.jpg";
import certificationsimage5 from "../assets/img/GST_Certificate_EFPL_001.jpg";
import { CertiCard } from './CertiCard';

export const Certificate = () => {
    const [openCertificate, setOpenCertificate] = useState(null);
    const [zoom, setZoom] = useState(1); // state to manage zoom level

    // List of certificates (you can add more images)
    const certificates = [
        { id: 1, thumbnail: certificationsimage1, certititle: "IEC Certificate", fullImage: certificationsimage1 },
        { id: 2, thumbnail: certificationsimage2, certititle: "FSSAI License Certificate", fullImage: certificationsimage2 },
        { id: 3, thumbnail: certificationsimage3, certititle: "Certificate of Incorporation", fullImage: certificationsimage3 },
        { id: 4, thumbnail: certificationsimage4, certititle: "MSME Certificate", fullImage: certificationsimage4 },
        { id: 5, thumbnail: certificationsimage5, certititle: "GST Certificate", fullImage: certificationsimage5 },
    ];

    const closesModal = () => {
        setOpenCertificate(null);
        setZoom(1); // Reset zoom when modal is closed
    };

    // Function to handle when a thumbnail is clicked
    const handleCertificateClick = (id) => {
        if (openCertificate === id) {
            setOpenCertificate(null);  // Close if clicked on the same image
        } else {
            setOpenCertificate(id);  // Open the new certificate
        }
    };

    // Function to handle when clicking outside the image (on the overlay)
    const handleCloseClick = (e) => {
        // Close if clicked on the overlay background (not on the image)
        if (e.target.classList.contains('certioverlay')) {
            setOpenCertificate(null);
            setZoom(1); // Reset zoom when clicked outside
        }
    };

    // Functions for zooming in and out
    const zoomIn = () => {
        if (zoom < 3) { // Limiting max zoom level
            setZoom(zoom + 0.5);
        }
    };

    const zoomOut = () => {
        if (zoom > 1) { // Limiting min zoom level
            setZoom(zoom - 0.5);
        }
    };

    return (
        <div className="certificates-page">
            <div className="section-header">
                <h3>Wall Of Certifications</h3>
                <div className="line-mf"></div>
            </div>
            <div className="certificates-container">
                {/* Displaying the thumbnails of certificates */}
                <div className="certificate-thumbnails">
                    {certificates.map((cert) => (
                        <div
                            key={cert.id}
                            className="certifications-image"
                            onClick={() => handleCertificateClick(cert.id)}
                        >
                            <img src={cert.thumbnail} alt={`Certificate ${cert.id}`} />
                            <h3>{cert.certititle}</h3>
                        </div>
                    ))}
                    <CertiCard />

                </div>

                {/* If a certificate is selected, show the full-size image */}
                {openCertificate !== null && (
                    <div className="certioverlay" onClick={handleCloseClick}>
                        <span className="certifications-close" onClick={closesModal}>
                            &times;
                        </span>
                        <div className="certificate-full-images">
                            <img
                                src={certificates[openCertificate - 1].fullImage}
                                alt={`Full Certificate ${openCertificate}`}
                                style={{ transform: `scale(${zoom})`, transition: "transform 0.3s ease" }} // Apply zoom
                            />
                            <h3>{certificates[openCertificate - 1].certititle}</h3>
                            <div className="zoom-controls">
                                <button onClick={zoomIn}>+</button>
                                <button onClick={zoomOut}>-</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
